import optimizelyClient from './client';
import config from './config';

const { CURRENT_USER_EXTERNAL_ID } = config;

export { default } from './client';
export const optimizelyTrackUserEvent = (event, attributes) => {
  optimizelyClient.track(event, CURRENT_USER_EXTERNAL_ID || null, attributes);
};

export const optimizelyFeatureEnabled = (feature) =>
  optimizelyClient.isFeatureEnabled(feature, CURRENT_USER_EXTERNAL_ID);
